import { GetServerSideProps } from 'next';
import { useIntl } from 'react-intl';

import Footer from '@/components/footer/FooterWrapper';
import LifetimeGiftCardLayout from '@/components/giftCard/LifetimeGiftCardLayout';
import giftCardMessages from '@/components/giftCard/LifetimeGiftCardLayout/messages';
import Layout from '@/components/layout/LayoutWrapper';
import { InitRequest } from '@/hooks/store';
import messages from '@/messages/messages';
import { initGiftPricing } from '@/utils/getInitialState/intiGiftPricing';
import getUrl from '@/utils/getUrl';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const GiftCardPage = () => {
	const { formatMessage } = useIntl();

	return (
		<Layout
			pageName="gift-card-lifetime"
			customSeo={{
				title: formatMessage(giftCardMessages.title),
				primaryDescription: formatMessage(giftCardMessages.description),
				description: formatMessage(giftCardMessages.description),
				url: `${getUrl('www')}/lifetime-gift-card`,
				imageUrl: `${getUrl('www')}/_n/images/social/lifetime-gift-card-social.jpg`,
			}}
			title={`Calm - ${formatMessage(messages.lifetimeGiftCardPageTitle)}`}
		>
			<LifetimeGiftCardLayout />
			<Footer />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const giftPrice = initGiftPricing(
		'lifetime',
		typeof context?.query?.coupon === 'string' ? context?.query?.coupon : null,
	);
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		{
			giftPrice: giftPrice ?? null,
		},
	);

	return {
		props: {
			initialState,
		},
	};
};

export default GiftCardPage;
